// Shared react-select styling so its controls sit flush with the native
// `.input-field` inputs they appear beside — same height, radius, border and
// focus ring.
const BORDER = 'var(--sel-border)';
const BORDER_FOCUS = '#7c3aed';
const TEXT = 'var(--sel-text)';
const PLACEHOLDER = 'var(--sel-placeholder)';

export const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),

  control: (base, state) => ({
    ...base,
    minHeight: '36px',
    borderRadius: '10px',
    backgroundColor: 'var(--sel-bg)',
    borderColor: state.isFocused ? BORDER_FOCUS : BORDER,
    boxShadow: state.isFocused ? '0 0 0 3px rgba(124, 58, 237, 0.12)' : 'none',
    fontSize: '0.875rem',
    '&:hover': { borderColor: state.isFocused ? BORDER_FOCUS : 'var(--sel-border-hover)' },
  }),

  valueContainer: (base) => ({ ...base, padding: '0 0.5rem' }),
  input: (base) => ({ ...base, margin: 0, paddingTop: 0, paddingBottom: 0, color: TEXT }),
  placeholder: (base) => ({ ...base, color: PLACEHOLDER, whiteSpace: 'nowrap' }),
  singleValue: (base) => ({ ...base, color: TEXT }),

  indicatorsContainer: (base) => ({ ...base, height: '34px' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: (base) => ({ ...base, padding: '0 0.5rem', color: 'var(--sel-indicator)' }),
  clearIndicator: (base) => ({ ...base, padding: '0 0.25rem', color: 'var(--sel-placeholder)' }),

  menu: (base) => ({
    ...base,
    // react-select's base carries a hard-coded white background — without
    // this override it shows as a light ring around the dark options.
    backgroundColor: 'var(--sel-menu-bg)',
    borderRadius: '12px',
    overflow: 'hidden',
    border: `1px solid ${BORDER}`,
    boxShadow: 'var(--sel-shadow)',
    fontSize: '0.875rem',
  }),
  menuList: (base) => ({
    ...base,
    backgroundColor: 'var(--sel-menu-bg)',
  }),
  option: (base, state) => ({
    ...base,
    backgroundColor: state.isSelected ? 'var(--sel-option-selected-bg)' : state.isFocused ? 'var(--sel-option-hover)' : 'var(--sel-menu-bg)',
    color: state.isSelected ? 'var(--sel-option-selected-text)' : TEXT,
    fontWeight: state.isSelected ? 600 : 400,
    ':active': { backgroundColor: 'var(--sel-option-active)' },
  }),

  multiValue: (base) => ({ ...base, backgroundColor: 'var(--sel-multi-bg)', borderRadius: '9999px' }),
  multiValueLabel: (base) => ({ ...base, color: 'var(--sel-multi-text)', fontSize: '0.75rem', fontWeight: 600 }),
  multiValueRemove: (base) => ({
    ...base,
    color: '#7c3aed',
    borderRadius: '9999px',
    ':hover': { backgroundColor: '#ddd6fe', color: '#4c1d95' },
  }),
};

export default selectStyles;
